import React from "react";
import { BurnAssessment } from "./BurnAssessment";
import ThumbUpRoundedIcon from "@mui/icons-material/ThumbUpRounded";
import ThumbDownRoundedIcon from "@mui/icons-material/ThumbDownRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import { alpha, SvgIcon, SvgIconProps } from "@mui/material";
import { BurnAssessmentColor } from "../assessment/BurnAssessmentColor";
import { IllegalArgumentError } from "shared-ts-utils-core";

export interface BurnAssessmentIconProps extends SvgIconProps {
  value: BurnAssessment;
}

export const BurnAssessmentIcon = React.forwardRef<
  SVGSVGElement,
  BurnAssessmentIconProps
>(({ value, ...props }, ref) => {
  const baseColor = BurnAssessmentColor[value];
  const color = alpha(baseColor, 0.7);
  if (value === BurnAssessment.Good) {
    return (
      <SvgIcon ref={ref} {...props} sx={{ color: color }}>
        <StarRoundedIcon />
      </SvgIcon>
    );
  } else if (value === BurnAssessment.Normal) {
    return (
      <SvgIcon ref={ref} {...props} sx={{ color: color, scale: 0.8 }}>
        <ThumbUpRoundedIcon />
      </SvgIcon>
    );
  } else if (value === BurnAssessment.Bad) {
    return (
      <SvgIcon ref={ref} {...props} sx={{ color: color, scale: 0.8 }}>
        <ThumbDownRoundedIcon />
      </SvgIcon>
    );
  } else if (value === BurnAssessment.Unknown) {
    return (
      <SvgIcon ref={ref} {...props} sx={{ color: color }}>
        <HelpRoundedIcon />
      </SvgIcon>
    );
  } else {
    throw new IllegalArgumentError("Unsupported BurnAssessment: " + value + "");
  }
});
BurnAssessmentIcon.displayName = "BurnAssessmentIcon";
